export const RSVP_REPLIES = [
  { id: 1, key: 'yes' },
  { id: 2, key: 'maybe' },
  { id: 3, key: 'no' },
];
